module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-magnifying-glass-de14a157a8ba14825ba469fb23c1aa2c.svg";